import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ContinentsScouts.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const ContinentScouts = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const {continentid} = useParams();

    const location = useLocation();
    const path = location.pathname;

    const [activeScouts, setActiveScouts] = useState([]);
    const [title, setTitle] = useState('');
    useEffect(() => {
        const staticData = [
            {   
                id: "1", 
                name: 'a',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'4', label:'Asia'},
                sport: 'Baseball',
            },
            {   
                id: "2", 
                name: 'b',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'7', label:'North America'},
                sport: 'Basketball, Football',
            },
            {   
                id: "3", 
                name: 'c',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "4", 
                name: 'd',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "5", 
                name: 'e',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'4', label:'Asia'},
                sport: 'Football',
            },
            {   
                id: "6", 
                name: 'f',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'4', label:'Asia'},
                sport: 'Football, Baseball',
            },
            {   
                id: "7", 
                name: 'g',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'7', label:'North America'},
                sport: 'Basketball, Baseball',
            },
            {   
                id: "8", 
                name: 'h',
                address: "test city, Alabama, United States",
                url:'',
                continent:{value:'7', label:'North America'},
                sport: 'Basketball',
            }
        ];
        //setActiveScouts(staticData);
    },[]);

    useEffect(() => {
            Promise.all([
                
            ])
            .then(() => {
         
            setIsLoading(false);
            })
         
        },[]);
        
       

    // const handleClick = (slug) => {
    //     window.location.href = '/scout/'+slug;
        
    // };

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };

    // const [currentPage, setCurrentPage] = useState(1);
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);

    const grouped = new Map();

    // Group by Sport
    if (Array.isArray(activeScouts)) {
    for (const row of activeScouts) {
        const sports = typeof row.sport === "string"
        ? row.sport.split(/\s*,\s*/)
        : []

        for (const sport of sports) {
        if (!grouped.has(sport)) grouped.set(sport, []);
        grouped.get(sport).push(row);
        }
    }
    }

    const flattenGroupedData = (grouped) => {
    const flat = [];
    for (const [sport, rows] of grouped) {
        for (const row of rows) {
        flat.push({ sport, row });
        }
    }
    return flat;
    };

    const flatRows = flattenGroupedData(grouped);

    const paginateFlatRows = (flatRows, pageSize = 50) => {
    const pages = [];
    let currentPage = [];
    let currentSport = null;
    let currentRows = [];

    for (let i = 0; i < flatRows.length; i++) {
        const { sport, row } = flatRows[i];

        if (currentSport !== sport) {
        if (currentRows.length > 0) {
            currentPage.push({ sport: currentSport, rows: currentRows });
            currentRows = [];
        }
        currentSport = sport;
        }

        currentRows.push(row);

        const rowCount =
        currentPage.reduce((sum, s) => sum + s.rows.length, 0) +
        currentRows.length;

        if (rowCount >= pageSize || i === flatRows.length - 1) {
        currentPage.push({ sport: currentSport, rows: currentRows });
        pages.push(currentPage);

        currentPage = [];
        currentRows = [];
        currentSport = null;
        }
    }

    return pages;
    };

    const pages = paginateFlatRows(flatRows, itemsPerPage);

    if (Array.isArray(activeScouts)) {
    for (const row of activeScouts) {
        if (!grouped.has(row.sport)) grouped.set(row.sport, []);
        grouped.get(row.sport).push(row);
    }
    }

    const totalPages = pages.length;
    const totalItems = flatRows.length;

    const startIndex = (page - 1) * itemsPerPage;
    const lastPageIndex = Math.min(startIndex + itemsPerPage, totalItems);

    // === Data Renderer
    const CategoryGrid = ({ title, rows }) => (
        <div>
        <div className="blue_box">{title}</div> 
            <ul>
                {rows.map(scout => (
                    <li key={scout.id}>
                        <div className="">
                            <div className=""><a href={scout.url} target="_blank">{scout.name}</a></div>  
                        </div>
                        {scout?.address && 
                            <div className="">        
                                <div className="">&nbsp;-  {scout.address}</div>  
                            </div>
                        } 
                    </li>
                ))}
            </ul>
        </div>
    );

    function goToNextPage() {
        setPage(prev => Math.min(prev + 1, totalPages));
    }

    function goToPrevPage() {
        setPage(prev => Math.max(prev - 1, 1));
    }

    function goToSpecificPage(pageNumber) {
        setPage(pageNumber);
    }
    function renderPaginationControls() {
        const maxButtons = 10;
    console.log(page);
    console.log("Items per page", itemsPerPage);
        let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxButtons - 1);

        if (endPage - startPage < maxButtons - 1) {
            startPage = Math.max(1, endPage - maxButtons + 1);
        }

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

        return (
            <div>
                {activeScouts.length > itemsPerPage && (
                    <div className="continent-scout-pagination" style={{ textAlign: "center" }}>
                        {page > 1 && (
                            <>
                                <button onClick={() => setPage(1)}>« First</button>
                                <button onClick={goToPrevPage}>‹ Previous</button>
                            </>
                        )}

                        {pageNumbers.map(num => (
                            <button
                                key={num}
                                onClick={() => goToSpecificPage(num)}
                                style={{
                                    fontWeight: num === page ? "bold" : "normal",
                                    color: num === page ? "#111" : "#2c99d2",
                                }}
                            >
                                {num}
                            </button>
                        ))}

                        {page < totalPages && (
                            <>
                                <button onClick={goToNextPage}>Next ›</button>
                                <button onClick={() => setPage(totalPages)}>Last »</button>
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
 
    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwscout/getscoutcontinentlist', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
               page: page,
            pagesize: itemsPerPage,
            id:continentid
              }),
            });
            const data = await response.json();
            setActiveScouts(data.data.result);
            setTitle(data.data.title);
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
    }, [page]); 

    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="continents-scouts-main">
                <Helmet><title>Continents Scouts</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="view-header">
                        <div style={{textAlign: "right"}}><a onClick={doBackAway} style={{cursor: "pointer"}}>« Back</a></div>
                        <div>
                            Displaying {totalItems === 0 ? 0 : startIndex + 1} - {lastPageIndex} of {totalItems}
                        </div>
                    </div>
                    {activeScouts.length === 0 ? (<p>There are currently no scouts available for your selection.</p>) : (
                        <div>
                           <h1>{title}</h1>
                            <div className="sport-specific-scout">
                                <ul>
                                    <div>
                                        {pages[page - 1]?.map(({ sport, rows }, idx) => (
                                            <CategoryGrid
                                                key={`${sport}-${rows[0]?.id}-${idx}`}
                                                title={sport}
                                                rows={rows}
                                            />
                                        ))}
                                    </div>
                                </ul>
                            </div>
                            {renderPaginationControls()}
                        </div>
                    )}
                </div>
                <div className="right">
                        {/* {
                            (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                            userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                                &&  */}
                                <SalespersonSidebar /> 
                            {/* } */}
                </div>
            </div>
        )}
        </>
    );
};
export default ContinentScouts;